const getGeneralMessageData = (messagesData) => messagesData.get('general');
const getSessionMessageData = (messagesData) => messagesData.get('session');

export {getGeneralMessageData, getSessionMessageData}